import { render, staticRenderFns } from "./BadSearchQueryAlert.vue?vue&type=template&id=e2102acc"
import script from "./BadSearchQueryAlert.vue?vue&type=script&lang=js"
export * from "./BadSearchQueryAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports